import { Component, OnInit, Input, Injector, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PartLoadingService, LoadingMethodService } from '../../../../phf.service';
import { PartDetailService } from '../part-detail.service';
import { Subject } from 'rxjs';
import { PartListService } from '../../part-list.service';
import { PartDetailComponent } from '../part-detail.component';
import { DistributionMethodDialogTemplate } from './distribution-method-edit/distribution-method-dialog.templet';
import { LoadingMethodDialogTemplate } from './loading-method-edit/loading-method-dialog.templet';
import { UnloadingMethodDialogTemplate } from './unloading-method-edit/unloading-method-dialog.templet';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'part-loading-tab',
  templateUrl: './part-loading-tab.component.html',
  styleUrls: ['../part-detail.component.scss']
})
export class PartLoadingTabComponent implements OnInit {
  part: any;
  editForm: FormGroup;
  isEditing: boolean;
  isLoading = false;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  // Dialog Fields
  showOrientationCarrierWindow: boolean;
  showOrientationEOLWindow: boolean;
  showOrientationDieWindow: boolean;
  showOrientationContainerWindow: boolean;
  showLoadingMethodWindow: boolean;
  partDistributionDialog: DistributionMethodDialogTemplate;
  loadingMethodDialog: LoadingMethodDialogTemplate;
  unloadingMethodDialog: UnloadingMethodDialogTemplate;
  partLoadingTabSave = true;
  isVisRadio = true;
  isOpen = true;

  @Input()
  set data(dataItem: any) {
    if (dataItem) {
      this.part = dataItem;
    }
  }

  @Output()
  updateEditForm: EventEmitter<FormGroup> = new EventEmitter();

  message: string;
  private readonly formBuilder: FormBuilder;
  private readonly partLoadingService: PartLoadingService;
  public readonly messageService: PartDetailService;
  private readonly partListService: PartListService;
  public readonly partDetailComponent: PartDetailComponent;
  private readonly partLoadingMethodService: LoadingMethodService;

  constructor(private readonly injector: Injector) {

    this.formBuilder = injector.get(FormBuilder);
    this.partLoadingService = injector.get(PartLoadingService);
    this.messageService = injector.get(PartDetailService);
    this.partListService = injector.get(PartListService);
    this.partDetailComponent = injector.get(PartDetailComponent);
    this.partLoadingMethodService = injector.get(LoadingMethodService);

    this.messageService.getMessage()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(message => {
        this.isEditing = message.editing;
      });
    this.isOpen = true;

    // Sets the default state of Orientation/Loading windows to closed
    this.showOrientationCarrierWindow = false;
    this.showOrientationEOLWindow = false;
    this.showOrientationDieWindow = false;
    this.showOrientationContainerWindow = false;
    this.showLoadingMethodWindow = false;
  }

  ngOnInit() {
    this.editForm = this.getEditForm();
    this.editForm.get('IsActive').setValue(true);
    this.messageService.partLoadingDataObject = this.editForm; // Sets pointer from messageService Part-Loading to this formGroup
    this.isLoading = true;
    this.getPartLoading();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private getEditForm(): FormGroup {
    return this.formBuilder.group({
      Id: [],
      PressId: [],
      PartId: [],
      ContainerExchange: [],
      ContainerLimits: [],
      TravelTime: [ 0.00, Validators.min(0)],
      TruckAccess: [0, Validators.min(0)],
      ContainersPerTrip: [0, Validators.min(0)],
      AssignedTrucks: [0, Validators.min(0)],
      UnloadingMethod: [],
      FirstOrientation: [],
      OrientationOnEOL: [],
      OrientationInDie: [],
      OrientationInContainer: [],
      DistributionMethod: [],
      LoadingMethod: [],
      OrientationCheck: [],
      IsActive: [],

    });
  }

  /**
  * Calls Part Loading API and populates view with part loading information
  */
  private getPartLoading() {
    if (this.part.PartLoadingId) {
      this.partLoadingService.read('/' + this.part.PartLoadingId)
        .then(partLoadingResult => {
          if (partLoadingResult) {
            this.editForm.reset(partLoadingResult);
          }
          this.isLoading = false;
        })
    }
    else { this.isLoading = false; }

  }


  onKeyUp = (e) => {
    if (isNaN(e.target.valueAsNumber)) {
      try {
        e.target.value = parseInt(e.target.value);
      } catch (e) {
        e.target.value = '';
      }
    }
  }

  setLoadingValue(x: string) {
    this.editForm.get("LoadingMethod").setValue(x);
  }
  setUnloadingValue(x: string) {
    this.editForm.get("UnloadingMethod").setValue(x);
  }
  setDistributionValue(x: string) {
    this.editForm.get("DistributionMethod").setValue(x);
  }
  displayFunction() {
    if (this.isOpen) {
      return "showRadio";
    } else {
      return "hideRadio";
    }
  }

  /**
   * Updates FirstOrientation editForm value with the Orientation 1st Tool/Carrier OrientationNote value
   * @param dataItem Value of the OrientationNote from the Orientation First Carrier Window
   */
  updateOrientationCarrierData(dataItem: any) {
    this.showOrientationCarrierWindow = false;
    this.editForm.get('FirstOrientation').setValue(dataItem);
    this.updateEditForm.emit(this.editForm);
  }

  /**
  * Updates FirstOrientation editForm value with the Orientation 1st Tool/Carrier OrientationNote value
  * @param dataItem Value of the OrientationNote from the Orientation First Carrier Window
  */
  updateOrientationEOLData(dataItem: any) {
    this.showOrientationEOLWindow = false;
    this.editForm.get('OrientationOnEOL').setValue(dataItem);
    this.updateEditForm.emit(this.editForm);
  }

  /**
  * Updates FirstOrientation editForm value with the Orientation 1st Tool/Carrier OrientationNote value
  * @param dataItem Value of the OrientationNote from the Orientation First Carrier Window
  */
  updateOrientationDieData(dataItem: any) {
    this.showOrientationDieWindow = false;
    this.editForm.get('OrientationInDie').setValue(dataItem);
    this.updateEditForm.emit(this.editForm);
  }

  /**
  * Updates FirstOrientation editForm value with the Orientation 1st Tool/Carrier OrientationNote value
  * @param dataItem Value of the OrientationNote from the Orientation First Carrier Window
  */
  updateOrientationContainerData(dataItem: any) {
    this.showOrientationContainerWindow = false;
    this.editForm.get('OrientationInContainer').setValue(dataItem);
    this.updateEditForm.emit(this.editForm);
  }

  closeOrientationCarrierWindow() {
    this.showOrientationCarrierWindow = false;
  }

  closeOrientationEOLWindow() {
    this.showOrientationEOLWindow = false;
  }


  closeOrientationDieWindow() {
    this.showOrientationDieWindow = false;
  }

  closeOrientationContainerWindow() {
    this.showOrientationContainerWindow = false;
  }

  onEditMethodClick() {
    this.unloadingMethodDialog = new UnloadingMethodDialogTemplate(this.injector, this.messageService, this.partListService, this);
    this.isOpen = false;
    this.partDetailComponent.isVisDialog = false;
    this.unloadingMethodDialog.next({
      UnloadingMethod: this.editForm.value.UnloadingMethod
    });
    this.partListService.openDialog(this.unloadingMethodDialog);

  }

  onEditDistributionClick() {
    this.partDistributionDialog = new DistributionMethodDialogTemplate(this.injector, this);
    this.isOpen = false;
    this.partDetailComponent.isVisDialog = false;
    this.partDistributionDialog.next({
      DistributionMethod: this.editForm.value.DistributionMethod
    });
    this.partListService.openDialog(this.partDistributionDialog);
  }

  onEditLoadingClick() {
    this.loadingMethodDialog = new LoadingMethodDialogTemplate(this.injector, this.messageService, this.partListService, this, this.partLoadingMethodService);
    this.isOpen = false;
    this.partDetailComponent.isVisDialog = false;
    this.loadingMethodDialog.next({
      LoadingMethod: this.editForm.value.LoadingMethod
    });
    this.partListService.openDialog(this.loadingMethodDialog);
  }

  onEditOrientationCarrierClick() {
    this.showOrientationCarrierWindow = true;
  }

  onEditEOLOrientationClick() {
    this.showOrientationEOLWindow = true;
  }

  onEditDIEOrientationClick() {
    this.showOrientationDieWindow = true;
  }

  onEditContOrientationClick() {
    this.showOrientationContainerWindow = true;
  }
}



